import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  note?: string | null;
  dataCy?: string;
}

const ReportPreviewSectionNote: FC<Props> = ({ note, dataCy }) => {
  const { t } = useTranslation();
  const trimmedNote = note?.trim();

  if (!trimmedNote) {
    return null;
  }

  return (
    <div
      className="analytics-report-section-note tw-w-full tw-break-inside-avoid tw-whitespace-pre-wrap tw-break-words tw-rounded-md tw-bg-grayscale-5 tw-p-3 tw-text-sm tw-text-grayscale-180"
      data-cy={dataCy}
      data-name={dataCy}
    >
      <span className="tw-font-semibold">
        {t('analyticsReports.createReport.sectionNote')}:{' '}
      </span>
      {trimmedNote}
    </div>
  );
};

export default ReportPreviewSectionNote;
